module.exports = __webpack_public_path__ + "static/img/envelope01en.812d11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope01en.png
// module id = 1T5B
// module chunks = 1